module.exports = __webpack_public_path__ + "static/media/71JK4qmCGyL._AC_SL1500_.b5cbadcf.jpg";